import React, { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { inventarioService } from '../../services/inventarioService';
import '../../styles/components.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const MovimientosChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadChartData();
  }, []);

  const loadChartData = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await inventarioService.getGraficoMovimientos();
      
      // Formatear las etiquetas de fecha para mejor visualización
      const formattedLabels = data.labels.map(label => {
        const [year, month, day] = label.split('-');
        const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 
                           'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
        const period = day === '01' ? '1-15' : '16-fin';
        return `${monthNames[parseInt(month) - 1]} ${period}`;
      });

      setChartData({
        labels: formattedLabels,
        datasets: data.datasets
      });
    } catch (err) {
      console.error('Error al cargar datos del gráfico:', err);
      setError('Error al cargar el gráfico de movimientos');
    } finally {
      setLoading(false);
    }
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12
          }
        }
      },
      title: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 12,
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 13
        },
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const value = context.parsed.y;
            label += value >= 0 ? `+${value}` : value;
            label += ' unidades';
            return label;
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: 11
          },
          maxRotation: 0,
          minRotation: 0,
          autoSkip: true,
          maxTicksLimit: 10
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          font: {
            size: 11
          },
          callback: function(value) {
            const formattedValue = value.toLocaleString('es-CL');
            return value >= 0 ? `+${formattedValue}` : formattedValue;
          }
        }
      }
    }
  };

  if (loading) {
    return (
      <div className="chart-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Cargando gráfico...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="chart-container">
        <div className="error-message">
          <span className="error-icon">⚠️</span>
          <p>{error}</p>
          <button className="btn btn-primary btn-sm" onClick={loadChartData}>
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  if (!chartData || !chartData.datasets || chartData.datasets.length === 0) {
    return (
      <div className="chart-container">
        <div className="empty-state">
          <span className="empty-icon">📊</span>
          <p>No hay datos de movimientos para mostrar</p>
        </div>
      </div>
    );
  }

  return (
    <div className="chart-container">
      <Line data={chartData} options={options} />
    </div>
  );
};

export default MovimientosChart;

// Made with Bob